import {Component, inject, OnInit} from '@angular/core';
import {BarChartComponent} from '../../../../shared/components/charts/bar-chart/bar-chart.component';
import {UtilityService} from '../../../../core/services/utility.service';
import {defaultRecordsDataRequestQueryParams} from '../../../../core/models/default-records-data-request-query-params';
import {PulseReportChartData} from '../../../../core/types/chart.types';
import {defaultPageableRecordData} from "../../../../core/models/default-pageable-record-data";
import {resources} from "../../../../core/models/resource/resources";
import {PulseReportChartService} from "./services/pulse-report-chart.service";

@Component({
  selector: 'app-pulse-report-chart-page',
  standalone: true,
  imports: [
    BarChartComponent
  ],
  templateUrl: './pulse-report-chart-page.component.html',
  styleUrl: './pulse-report-chart-page.component.scss'
})
export class PulseReportChartPageComponent implements OnInit{
  protected utilityService: UtilityService = inject(UtilityService);
  private pulseReportChartService: PulseReportChartService = inject(PulseReportChartService);

  public pulseReportChartData: PulseReportChartData = [];

  public async ngOnInit(): Promise<void> {
    await this.getData();
  }

  public async getData(): Promise<void> {
    const queryParams = {
      ...defaultRecordsDataRequestQueryParams,
      periodFrom: '01.09.2024',
      periodTo: '30.09.2024'
    }
    const data: any = await this.pulseReportChartService.getRecordTableChartData(resources['pulse-reports'].path, queryParams).catch(() => defaultPageableRecordData);
    this.pulseReportChartData = data[0].metrics;
  }
}
